/*
 * @Author: your name
 * @Date: 2021-04-09 15:36:52
 * @LastEditTime: 2021-04-15 17:19:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ecmp5-client-web/src/mock/index.js
 */

import Mock from 'mockjs'
import config from '@/api/config.js'
const baseUrl = config.baseUrl.dev
//使用mockjs模拟数据
// Mock.mock(baseUrl + '/app/v1/user_invoices/orders/list', {
//     "results|12-40": [{
//         amount: "@float(1.5, 234.3)",
//         charge_station: { name: "小可乐金融基地充电站", serial_number: "1767dfc0-0104-480d-bd0f-4bafeb7a32ee" },
//         "charge_station_name|1": ['小可乐金融基地充电站', '横琴中央汇充电站', '华发商都c区充电站'],
//         charger: { name: "交流5号", serial_number: "08b65f39-1e97-491b-b571-c9f595b0f00d" },
//         charging_finished_at: "@natural(1610181702, 1640162502)",
//         charging_started_at: 1603261941,
//         consumed_power: "@float(1.4, 45.2)",
//         description: "",
//         elapsed_time: "@natural(122, 600)",
//         has_comment: false,
//         isItemSelected: false,
//         order_type: "normal",
//         payable_amount: "@float(1.5, 134.3)",
//         payment: { id: "a5f7896c-8dd2-4011-8ae1-8ce5040d91dc", trade_number: "O20102109562131618", amount: "-23.88", user_balance: "78.5", actual_amount: "@float(1.4, 145.2)" },
//         status: "paid",
//         status_name: "已支付",
//         time: "2020-10-21  14:32",
//         trade_number: "@natural(100,93425345345)",
//     }],
// });
//发票抬头
// Mock.mock(baseUrl + '/app/v1/user_invoices', {
//     "results|3-10": [{
//         id: "@natural(123423423412,24234324321432)",
//         "title|1": [ '小可乐科技', '牛肚大排档', '雪碧有限公司', '快有钱金融有限公司'],
//         "receiver_email|1": [ 'jy@lcola.cn', 'niuduzhenhaochi@qq.com', 'xuebibuhaohe@163.com', 'kuaiyouqian@163.com'],
//     }],
// });
//已有运营商列表
// Mock.mock(baseUrl + '/app/v1/user_invoices/service_provider/invoice_records', {
//     "results|3-10": [{
//         id: "@natural(123423423412,2423432432132432)",
//         "name|1": [ '小可乐科技', '牛肚大排档', '雪碧有限公司', '快有钱金融有限公司'],
//         order_count: "@Integer(5,20)"
//     }],
// });
//开票记录列表
// Mock.mock(baseUrl + '/app/v1/user_invoices/records/list', {
//     "results|3-10": [{
//         id: "@natural(123423423412,2423432432432432)",
//         "title|1": [ '小可乐科技', '牛肚大排档', '雪碧有限公司', '快有钱金融有限公司'],
//         chage_limit: "@Integer(5,20)",
//         amount: "@float(1.5, 234.3)",
//         time: "2020-10-21  14:32",
//         "status|1":[ 'done', 'reject', 'cancel', 'in_progress'],
//     }],
// });
//首页 swipe 广告轮播
Mock.mock(baseUrl + '/app/v1/user/notice', {
    "result": {
        "url": [ '@/images/banner.png', '@/images/banner2.png', '@/images/banner3.png', '@/images/banner4.png'],
    },
});